import { render, staticRenderFns } from "./PageLoading.vue?vue&type=template&id=3b90acb4&scoped=true&lang=html&"
import script from "./PageLoading.vue?vue&type=script&lang=js&"
export * from "./PageLoading.vue?vue&type=script&lang=js&"
import style0 from "./PageLoading.vue?vue&type=style&index=0&id=3b90acb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b90acb4",
  null
  
)

export default component.exports